import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '@store/authStore';
import ProgramManagerDashboard from '@pages/admin/dashboard';
import AdminDashboard from '@pages/admin/AdminDashboard';
import HRDashboard from '@pages/hr/HRDashboard';
import EmployeeDashboard from '@pages/employee/EmployeeDashboard';
import AssessmentDashboard from '@pages/assessmentCreator/AssessmentDashboard';

const DashboardRouter: React.FC = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  // Redirect to appropriate dashboard based on role
  useEffect(() => {
    if (location.pathname === '/') {
      console.log('DashboardRouter: Redirecting root to /dashboard');
      navigate('/dashboard', { replace: true });
    }
  }, [location.pathname, navigate]);

  console.log('DashboardRouter: Current path:', location.pathname, 'User role:', user?.role);

  // Render dashboard based on user role
  if (user?.role === 'Admin') {
    console.log('DashboardRouter: Rendering Admin Dashboard');
    return <AdminDashboard />;
  }

  if (user?.role === 'HR') {
    console.log('DashboardRouter: Rendering HR Dashboard');
    return <HRDashboard />;
  }

  if (user?.role === 'Employee') {
    console.log('DashboardRouter: Rendering Employee Dashboard');
    return <EmployeeDashboard />;
  }

  if (user?.role === 'Assessment Creator') {
    console.log('DashboardRouter: Rendering Assessment Dashboard');
    return <AssessmentDashboard />;
  }

  // Default to Program Manager Dashboard
  console.log('DashboardRouter: Rendering Program Manager Dashboard');
  return <ProgramManagerDashboard />;
};

export default DashboardRouter;
